import * as React from 'react';
import { Link } from 'react-router-dom';
import Header from './sharedcomponents/header';

export default class Dashboard extends React.Component<any, any> {
    public render() {
        return (
            <div>
                <Header />
                <div className="splash-page">
                    <div className="login-logo"><img src="/assets/images/login-logo.png" /></div>
                    <div className="splash-box">
                        <ul>
                            <li><Link to={`/subscriptionReports/allUsers`} >Subscription Reports</Link></li>
                            <li><Link to={`/productionreports/All`} >Production Reports</Link></li>
                            <li><Link to={`/productionSpeed/All`} >Production Speed Reports</Link></li>
                        </ul>
                        <ul>
                            <li><Link to={`/enclosurePO/All`} >Enclosure PO Reports</Link></li>
                            <li><Link to={`/all41Projects/All`} >All 4.1 Projects Reports</Link></li>
                            <li><Link to={`/openModsReport/All`} >Open Mods Report</Link></li>
                        </ul>
                    </div>
                    <div className="splash-text"></div>
                </div>
                <div className="login-outer"></div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/dashboard.tsx